import saga from "./saga";
import slice from "./slices.ts";

const preference = {
  slice,
  saga,
};

export default preference;
